import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function Terms() {
  return (
    <>
      <Breadcrumb title="Terms of Service" />

      <div className="privacy-policy-section py-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-md-12">
              <div
                className="privacy-content wow fadeInUp"
                data-wow-delay="0.25s"
              >
                <p>
                  <strong>All government taxes</strong> (GST, service tax, or
                  any other applicable statutory taxes) will be borne by the
                  client as per prevailing government regulations.
                </p>

                <p>
                  <strong>Costs related to paid services — </strong>
                  including paid backlinks for blog posts, paid campaigns,
                  social media advertisements, Google Ads, search engine ads,
                  sponsored posts, printing, corporate gifts, material
                  procurement, delivery/logistics, official site visits, server
                  migration, hosting space, and managed services — will be borne
                  by the client on actuals. These activities cover planning,
                  setup, monitoring, optimization, and reporting based on the
                  selected platforms or services.
                </p>

                <p>
                  <strong>Third-party software or tool costs — </strong>
                  including but not limited to ERP, CRM, CDN, Canva, CorelDraw,
                  Photoshop, Adobe Premiere Pro, ChatGPT Pro, Gemini Pro,
                  domains, servers, and any required licensing — will be borne
                  by the client on actuals.
                </p>

                <p>
                  <strong>All products, tools, and software</strong> will be
                  installed and deployed on the client’s IT infrastructure
                  (On-Premise or Cloud), and all associated costs will be borne
                  by the client.
                </p>

                <p>
                  <strong>Payment Terms:</strong> 100% payment is required in
                  advance. No credit or deferred payment terms are permitted.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
